import { render, staticRenderFns } from "./StatusShort.vue?vue&type=template&id=b035e4cc"
import script from "./StatusShort.vue?vue&type=script&lang=js"
export * from "./StatusShort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports